import { userQueryOptions } from '@repo/cf-user/hooks/use-user-data'

import { useUserProfileInfoQuery } from '@web/gen/user'

export function useUserProfileQuery() {
  return useUserProfileInfoQuery(undefined, {
    ...userQueryOptions,
    select(data) {
      return data.me?.user
    },
  })
}

export function useUserProfileProgress() {
  const { isPending, data } = useUserProfileQuery()
  const { firstName, lastName, avatarUrl, contentInterests = [], craftingTypes = [] } = data || {}
  const isAvatarUserUploaded =
    avatarUrl &&
    (avatarUrl?.includes('wp-content/uploads') ||
      (!avatarUrl?.includes('wp-content/uploads') && !avatarUrl?.includes('creativefabrica.com')))
  return {
    isLoading: isPending,
    firstName,
    lastName,
    avatarUrl,
    contentInterests,
    craftingTypes,
    isAvatarUserUploaded,
    progress: Math.floor(
      (((firstName ? 1 : 0) +
        (lastName ? 1 : 0) +
        (isAvatarUserUploaded ? 1 : 0) +
        (contentInterests.length ? 1 : 0) +
        (craftingTypes.length ? 1 : 0)) /
        5) *
        100,
    ),
  }
}
